import GameUtil from "../../../../utility/game_util";
import { joinUtil } from "../../../public/join_util";
import EventManager from "../../../../manager/event_manager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class GameItemInfo extends cc.Component {

    @property(cc.Sprite)
    icon:cc.Sprite = null;

    @property(cc.Label)
    roundNumb:cc.Label = null;

    private data:any;

    onLoad(){
        this.icon.node.on('click',()=>{
            //游戏调整       
            if (this.data) {
                //EventManager.instance.dispatch('_click_game_item_',this.data.gameId)
            }     
        })
    }

    refreshGameInfo(data:any,awardIconFunc:Function){
        this.data = data;
        this.roundNumb.string = GameUtil.currencyFormatting(data.totalRound,0) ;
        let sp = awardIconFunc(data.gameId)
        if (sp) {
            this.icon.spriteFrame = sp;
        }
    }
}
